const clinicTimezoneOffsetMinutes = -3 * 60;

const parts = (value) => String(value || '').match(
  /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::\d{2})?(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/,
);

export const clinicDateKey = (value) => {
  const match = parts(value);
  if (!match) return '';
  if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(String(value))) return `${match[1]}-${match[2]}-${match[3]}`;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const clinicDate = new Date(date.getTime() + clinicTimezoneOffsetMinutes * 60 * 1000);
  return `${clinicDate.getUTCFullYear()}-${String(clinicDate.getUTCMonth() + 1).padStart(2, '0')}-${String(clinicDate.getUTCDate()).padStart(2, '0')}`;
};

export const clinicTimeKey = (value) => {
  const match = parts(value);
  if (!match) return '';
  if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(String(value))) return `${match[4]}:${match[5]}`;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const clinicDate = new Date(date.getTime() + clinicTimezoneOffsetMinutes * 60 * 1000);
  return `${String(clinicDate.getUTCHours()).padStart(2, '0')}:${String(clinicDate.getUTCMinutes()).padStart(2, '0')}`;
};

export const formatClinicDateTime = (value) => {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return '';
    const clinicDate = new Date(value.getTime() + clinicTimezoneOffsetMinutes * 60 * 1000);
    return `${clinicDate.getUTCFullYear()}-${String(clinicDate.getUTCMonth() + 1).padStart(2, '0')}-${String(clinicDate.getUTCDate()).padStart(2, '0')}T${String(clinicDate.getUTCHours()).padStart(2, '0')}:${String(clinicDate.getUTCMinutes()).padStart(2, '0')}`;
  }
  return `${clinicDateKey(value)}T${clinicTimeKey(value)}`;
};
